import { STORAGE_KEYS as o } from "./storage-manager.js";
import u from "./subscription-manager.js";
import r from "../../shared-lib/braze-shared-lib.js";
export default class kt {
  constructor(t, i, s) {
    (this.h = t),
      (this.xn = i || !1),
      (this.zn = s),
      (this.qn = new u()),
      (this.Gn = 0),
      (this.Hn = 1);
  }
  Jn() {
    return this.xn;
  }
  Kn() {
    return this.h.I(o.q.Ln);
  }
  setSdkAuthenticationSignature(t) {
    const i = this.Kn();
    this.h.B(o.q.Ln, t);
    const s = r.xt.Ft;
    new r.qt(s, r.D).setItem(s.$t.Mn, this.Hn, t), i !== t && this.Qs();
  }
  On() {
    this.h.Xs(o.q.Ln);
    const t = r.xt.Ft;
    new r.qt(t, r.D).br(t.$t.Mn, this.Hn);
  }
  subscribeToSdkAuthenticationFailures(t) {
    return this.zn.ut(t);
  }
  Qn(t) {
    this.zn.St(t);
  }
  Rn() {
    this.qn.removeAllSubscriptions();
  }
  Vn() {
    this.Gn += 1;
  }
  Wn() {
    return this.Gn;
  }
  Qs() {
    this.Gn = 0;
  }
}
